module.exports = {"subtitle":"Una introducción interactiva a la red estereográfica.","geocompassTab":"Brújula","stereonetTab":"Red estereográfica","contextTab":"Vista 3D"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/layout/es/messages.json
// module id = 299
// module chunks = 0